export const routes = {
    home: '/',
    orders: '/orders',
    update_order:":id",
    login: 'login',


}